import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { createPinia } from "pinia";

import router from "./router";
import { useToast } from "./services/useToast";
import "vuetify/styles";
import "vuetify/dist/vuetify.min.css";
// Imported after Vuetify so the brand tokens override its defaults.
import "./assets/brand.css";

const pinia = createPinia();
const { showToast } = useToast();

const app = createApp(App);
app.use(router).use(vuetify);
app.use(pinia);

// Last resort. Anything that reaches here escaped a view's own error handling, and without it
// the user gets a blank screen with no way to tell that something broke.
app.config.errorHandler = (error, instance, info) => {
  console.error("Unhandled application error", { error, info });
  showToast(
    "Váratlan hiba történt. Frissítsd az oldalt, és próbáld újra.",
    "error",
    6000
  );
};

app.mount("#app");
